import { render, staticRenderFns } from "./siteCategoryManage.vue?vue&type=template&id=5f420a82&scoped=true&"
import script from "./siteCategoryManage.vue?vue&type=script&lang=js&"
export * from "./siteCategoryManage.vue?vue&type=script&lang=js&"
import style0 from "./siteCategoryManage.vue?vue&type=style&index=0&id=5f420a82&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f420a82",
  null
  
)

export default component.exports